import {LANGUAGES} from './i18n.mjs';
// Local settings still work when storage is blocked. A stored w2c-style (the former map style choice) is ignored.
export function preferences(storage, dark) {
  const read = key => { try { return storage?.getItem(key); } catch { return null; } };
  const stored = read('w2c-theme'), explicitTheme = ['light','dark'].includes(stored) ? stored : null;
  const lang = read('w2c-lang');
  return {theme: resolveTheme(explicitTheme || 'auto', dark), mode: explicitTheme || 'auto', explicitTheme, live: read('w2c-live') !== 'off',
    secondary: ['kw','price','off'].includes(read('w2c-secondary')) ? read('w2c-secondary') : 'kw',
    lang:LANGUAGES.includes(lang) ? lang : 'auto'};
}
// w2c-theme: light | dark | auto; anything else (or nothing) means auto, which follows prefers-color-scheme.
export const THEME_MODES = ['auto', 'light', 'dark'];
export const resolveTheme = (mode, dark) => mode === 'light' || mode === 'dark' ? mode : dark ? 'dark' : 'light';
export function savePreference(key, value, storage = localStorage) { try { storage.setItem(`w2c-${key}`,value); } catch { /* Private browsing may continue. */ } }
